var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('profile-layout',[(_vm.error)?_c('error'):_vm._e(),(_vm.isLoaded)?_c('div',[(!_vm.hasCompleted)?_c('not-complited'):_c('disclaimer-text'),_c('session-list')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }